import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

export default function Protected({ children, adminOnly = false }) {
    const { user } = useAuth();
    if (user === undefined) {
        return (
            <div className="min-h-[60vh] grid place-items-center text-zinc-500 font-mono text-xs uppercase tracking-widest">
                Authenticating…
            </div>
        );
    }
    if (!user) return <Navigate to="/auth" replace />;
    if (adminOnly && user.role !== "admin") return <Navigate to="/terminal" replace />;
    return children;
}
